import React, { useState } from "react";

const WorkFlow = () => {
  const [activeStep, setActiveStep] = useState(null);

  return (
    <section className="py-[50px] px-5 bg-[#f9f6f6] font-['Segoe_UI',Tahoma,Geneva,Verdana,sans-serif]">
      
      {/* Title */}
      <h2 className="text-center text-[2rem] font-semibold text-[#444]">
        How does Crowdfunding on DonatePe work?
      </h2>

      <div className="w-[70px] h-[4px] bg-[#00b7b3] mx-auto my-[15px] mb-[50px] rounded"></div>

      {/* Main Container */}
      <div className="flex justify-between flex-wrap gap-[30px]">

        {/* LEFT STEPS */}
        <div className="flex-1 min-w-[280px] ml-[300px] max-md:ml-0">

          {/* Step 1 */}
          <div
            onClick={() => setActiveStep(1)}
            className="flex flex-col items-start mb-[40px] cursor-pointer transition-all duration-300 max-md:items-center"
          >
            <span
              className={`text-[2.5rem] font-bold mb-[10px] ${
                activeStep === 1 ? "text-[#00b7b3]" : "text-[#bdbdbd]"
              }`}
            >
              1.
            </span>

            <h3
              className={`text-[1.3rem] font-semibold mb-[5px] ${
                activeStep === 1 ? "text-[#00b7b3]" : "text-[#777]"
              }`}
            >
              Start a free fundraiser
            </h3>

            <p
              className={`text-[1rem] leading-[1.5] ${
                activeStep === 1 ? "text-[#00b7b3]" : "text-[#9a9a9a]"
              }`}
            >
              Start a free fundraiser by filling in all the relevant
              <br /> details
            </p>
          </div>

          <div
            className={`w-[62%] h-[2px] rounded mb-[20px] mt-[-25px] ${
              activeStep === 1 ? "bg-[#00b7b3]" : "bg-[#ddd]"
            } max-md:mx-auto max-md:w-[60%]`}
          ></div>

          {/* Step 2 */}
          <div
            onClick={() => setActiveStep(2)}
            className="flex flex-col items-start mb-[40px] cursor-pointer transition-all duration-300 max-md:items-center"
          >
            <span
              className={`text-[2.5rem] font-bold mb-[10px] ${
                activeStep === 2 ? "text-[#00b7b3]" : "text-[#bdbdbd]"
              }`}
            >
              2.
            </span>

            <h3
              className={`text-[1.3rem] font-semibold mb-[5px] ${
                activeStep === 2 ? "text-[#00b7b3]" : "text-[#777]"
              }`}
            >
              Share Your Fundraiser
            </h3>

            <p
              className={`text-[1rem] leading-[1.5] ${
                activeStep === 2 ? "text-[#00b7b3]" : "text-[#9a9a9a]"
              }`}
            >
              Share your fundraiser with friends, family and
              <br /> strangers to raise funds quickly
            </p>
          </div>

          <div
            className={`w-[62%] h-[2px] rounded mb-[20px] mt-[-25px] ${
              activeStep === 2 ? "bg-[#00b7b3]" : "bg-[#ddd]"
            } max-md:mx-auto max-md:w-[60%]`}
          ></div>

          {/* Step 3 */}
          <div
            onClick={() => setActiveStep(3)}
            className="flex flex-col items-start mb-[40px] cursor-pointer transition-all duration-300 max-md:items-center"
          >
            <span
              className={`text-[2.5rem] font-bold mb-[10px] ${
                activeStep === 3 ? "text-[#00b7b3]" : "text-[#bdbdbd]"
              }`}
            >
              3.
            </span>

            <h3
              className={`text-[1.3rem] font-semibold mb-[5px] ${
                activeStep === 3 ? "text-[#00b7b3]" : "text-[#777]"
              }`}
            >
              Withdraw All Donations
            </h3>

            <p
              className={`text-[1rem] leading-[1.5] ${
                activeStep === 3 ? "text-[#00b7b3]" : "text-[#9a9a9a]"
              }`}
            >
              Withdraw all the money you receive at any point
              <br /> in your fundraising journey
            </p>
          </div>

          <div className="w-[62%] h-[2px] bg-[#00b7b3] rounded mt-[-25px] max-md:mx-auto max-md:w-[60%]"></div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="flex-1 min-w-[250px] flex justify-center">
          <img
            src="/mobile.png"
            alt="Mobile Preview"
            className="w-[320px] max-w-full rounded-[20px] shadow-[0_10px_20px_rgba(0,0,0,0.2)]"
          />
        </div>
      </div>

      {/* FOOTER */}
      <div className="text-center py-[40px] px-5 mt-[50px] bg-[#f9f6f6]">
        <p className="font-semibold text-[1.1rem] text-[#333] mb-[20px]">
          Your fundraising journey is successful! We wish you a speedy recovery!
        </p>

        <div className="flex justify-center gap-[15px] flex-wrap">
          <button className="px-[25px] py-[12px] text-[0.95rem] font-semibold rounded-[6px] bg-[#00b7b3] text-white shadow-[0_8px_10px_rgba(55,205,221,0.3)] -translate-y-[2px] hover:bg-[#00a69c] transition">
            START A FREE FUNDRAISER
          </button>

          <button className="px-[25px] py-[12px] text-[0.95rem] font-semibold rounded-[6px] bg-white text-[#00b7b3] border-[2px] border-[#00b7b3] hover:bg-[#e6f5f0] transition">
            GET A CALLBACK
          </button>
        </div>
      </div>
    </section>
  );
};

export default WorkFlow;
